<template>
  <nav id="nav" :class="aColor ? 'showWite' : ''">
    <div><img src="./assets/image/toplogo.png" class="toplogo" alt="与你相练"></div>
    <div>
      <el-tabs class="nav-tab" v-model="activeName">
        <el-tab-pane name="#/">
          <template #label>
            <router-link to="/">首页</router-link>
          </template>
        </el-tab-pane>
        <el-tab-pane name="#/productInfo">
          <template #label>
            <router-link to="/productInfo">管理系统</router-link>
          </template>
        </el-tab-pane>
        <el-tab-pane name="#/learningProducts">
          <template #label>
            <router-link to="/learningProducts">智能硬件</router-link>
          </template>
        </el-tab-pane>
        <el-tab-pane name="#/about">
          <template #label>
            <router-link to="/about">关于我们</router-link>
          </template>
        </el-tab-pane>
      </el-tabs>
      <div class="login" @click="openGym">后台管理</div>
    </div>
  </nav>
  <keep-alive>
    <router-view @changeColor="changeColor"></router-view></keep-alive>
  <FooterVue v-if="false"></FooterVue>
</template>

<script setup>
import { ref } from 'vue';
import FooterVue from './components/FooterVue.vue';
let aColor = ref('');
const activeName = ref(location.hash)
function openGym() {
  window.open('https://saas.raganafit.com')
}
const changeColor = (value) => {
  aColor.value = value;
}
</script>

<style lang="scss"> @import '@/assets/css/style.css';

 .toplogo {
   width: 148px;
 }

 html,
 body {
   height: 100%;
   padding: 0;
   margin: 0;
 }

 li {
   list-style: none;
 }

 a {
   text-decoration: none;
   cursor: pointer;
 }

 #app {
   height: 100%;
   font-family: "Microsoft Yahei";
 }

 #footer {
   height: 20%;
   background-color: #000;
   color: #fff;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   font-size: 12px;
   position: fixed;
   bottom: 0;
   width: 100%;

   span {
     margin: 8px;
   }

   aside {
     position: absolute;
     top: 30%;
     right: 100px;

     div {
       display: flex;
       flex-direction: column;
       align-items: center;
       float: left;
       margin-left: 45px;
     }
   }
 }

 #nav {
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: fixed;
   z-index: 10;
   color: #fff;
   width: 100%;
   padding: 0px 180px;
   box-sizing: border-box;
   height: 80px;
   background: rgba(0, 0, 0, 0.2);
   box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.06);
   opacity: 1;
   -webkit-backdrop-filter: blur(24px);
    backdrop-filter: blur(24px);
   .nav-tab {
     display: inline-block;
     vertical-align: middle;
     height: 80px;

     .el-tabs__item {
       height: 80px;
       line-height: 80px;
       width: 72px;
       padding: 0px;
       margin-left: 50px;
       text-align: center;

       a {
         width: 100%;
         height: 100%;
         display: block;
       }
     }

     .el-tabs__active-bar {
       background-color: rgba(229, 10, 51, 1);
       width: 72px !important;
     }

     .el-tabs__nav-wrap::after {
       background: none !important
     }

     .el-tabs__item.is-active a {
       color: rgba(229, 10, 51, 1) !important;
     }
   }

   a {
     font-size: 18px;
     font-family: AlibabaPuHuiTi-Regular, Source Han Sans CN, Source Han Sans CN;
     font-weight: 400;
     color: #FFFFFF;
   }
   
   .login {
     height: 36px;
     line-height: 36px;
     border-radius: 4px 4px 4px 4px;
     opacity: 1;
     padding: 0px 13px;
     border: 1px solid #FFFFFF;
     font-size: 16px;
     font-weight: 400;
     color: #ffffff;
     display: inline-block;
     margin-left: 200px;
     cursor: pointer;
   } 
   a:hover{
    color: rgba(229, 10, 51, 1);
   }
   .login:hover{
    color: rgba(229, 10, 51, 1);
     border: 1px solid rgba(229, 10, 51, 1);
   }
 
 }

 #nav.showWite {
   background: rgba(255, 255, 255, 0.8);
   box-shadow: 0px 6px 10px 0px rgba(229, 10, 51, 0.06);

   color: #666666;

   a {
     color: #666666;
   }

   .login {
     color: #666666;
     border: 1px solid #333333;
   }
   a:hover{
    color: rgba(229, 10, 51, 1);
   }
   .login:hover{
    color: rgba(229, 10, 51, 1);
     border: 1px solid rgba(229, 10, 51, 1);
   }

 }
</style>
